const r = "_wrapper_1p2rm_1", b = "_breadcrumbs_1p2rm_7", e = {
  wrapper: r,
  "breadcrumbs--bold": "_breadcrumbs--bold_1p2rm_7",
  breadcrumbs: b
};
export {
  b as breadcrumbs,
  e as default,
  r as wrapper
};
